import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import { RegisterOptions } from "react-hook-form";
import { isValidHttpUrl } from "../../utils/isValidHttpUrl";

type ReactHookFormRules = Omit<
  RegisterOptions,
  "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
>;

interface PhoneNumberValidatorOptions {
  prefix?: string;
  defaultCountry?: CountryCode;
}

export const useFormFieldsValidators = () => {
  const requiredValidator = (): ReactHookFormRules => ({
    required: "This field is required",
    validate: (value) =>
      value.trim() !== "" ? true : "This field is required",
  });

  const emailValidator = (): ReactHookFormRules => ({
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Invalid email address",
    },
  });

  const lengthValidator = (maxLength: number): ReactHookFormRules => ({
    maxLength: {
      value: maxLength,
      message: "The input exceeds the maximum allowed length",
    },
  });

  const urlValidator = (isProtocolRequired?: boolean): ReactHookFormRules => ({
    validate: (value) =>
      isValidHttpUrl(value, isProtocolRequired) || !value
        ? true
        : "Invalid URL address",
  });

  const phoneNumberValidator = (
    options: PhoneNumberValidatorOptions = {}
  ): ReactHookFormRules => ({
    validate: (value: string) => {
      if (!value) {
        return true;
      }

      value = options.prefix ? options.prefix.concat(value) : value;

      return (
        isValidPhoneNumber(value, {
          defaultCountry: options.defaultCountry,
        }) || "Invalid phone number"
      );
    },
  });

  return {
    requiredValidator,
    emailValidator,
    lengthValidator,
    urlValidator,
    phoneNumberValidator,
  };
};
